import React, {useEffect, useState} from "react"
import {useParams} from "react-router";
import {apiUrl} from "../../constants/constants";
import "./BrandArchive.scss"
import {TextAndCarousel} from "../ProductContent/contents/contentComponents";
import FocusedPhotoReview from "../FocusedPhotoReview/FocusedPhotoReview.component";
import BrandArchiveGalleryImageModalComponent
    from "./BrandArchiveGalleryImageModal/BrandArchiveGalleryImageModal.component";
import {useNavigate} from "react-router-dom";
import {convertMonthV2} from "../../utils/utils";
import {SmallArrow} from "../../../assets/Arrows";
import {ListIcon} from "../../../assets/ListIcon";
import {AppContext} from "../../context/AppContext";

interface IContentData {
    content: any[]
    end_date: string
    id: number
    register_date: string
    slug: string
    thumbnail_url: string
    title: string
    use_yn: boolean
    view_count: number
    writer: string
    background_url?: string
}


function BrandArchiveComponent() {
    const {boardId} = useParams()
    const {spinnerStore} =
        React.useContext(AppContext);
    const [targetImages, setTargetImages] = useState<{ url: string }[]>([])
    const [data, setData] = useState<IContentData>()
    const [targetIndex, setTargetIndex] = useState<number>(0)
    const {slug} = useParams()
    const [isImageModalVisible, setIsImageModalVisible] = useState(false)
    const [prevContent, setPrevContent] = useState<IContentData>()
    const [nextContent, setNextContent] = useState<IContentData>()
    const navigate = useNavigate()

    useEffect(() => {
        if (boardId) {
            spinnerStore.setIsSpinnerShow(true)
            fetch(apiUrl + `/api/boards/contents/${boardId}`, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'},
                credentials: 'include'
            }).then(res => res.json()).then(res => {
                const resData = res.result
                resData.content = JSON.parse(res.result.content)
                setData(res.result)
                spinnerStore.setIsSpinnerShow(false)
            })
        } else if (slug) {
            spinnerStore.setIsSpinnerShow(true)
            fetch(apiUrl + `/api/boards/contents/slug/${slug}`, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'},
                credentials: 'include'
            }).then(res => res.json()).then(res => {
                const resData = res.result
                resData.content = JSON.parse(res.result.content)
                setData(res.result)
                spinnerStore.setIsSpinnerShow(false)
            })
        }
    }, [slug, boardId])

    useEffect(() => {
        if (data) {
            if (data?.id) {
                getContent(data.id, 'prev')
                getContent(data.id, 'next')
            }
        }
    }, [data])

    const reset = () => {
        setData(null)
        setPrevContent(null)
        setNextContent(null)
    }

    const getContent = (contentsId, action) => {
        fetch(apiUrl + `/api/boards/contents/${contentsId}/${action}`, {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            credentials: 'include'
        }).then(res => res.json()).then(res => {
                const resData = res.result
                if (action === "prev") {
                    setPrevContent(resData)
                } else if (action === "next") {
                    setNextContent(resData)
                }
            }
        )
    }

    const stringToHTML = (str: any) => {
        const parser = new DOMParser();
        return parser.parseFromString(str, 'text/html');
    };
    const convertDataByType = (item: any) => {
        switch (item.type) {
            case 'paragraph': {
                const text = item.data.text.replaceAll('<a', `<a target='blank'`)
                return <div className={`brand-archive-${item.type}`}
                            style={{textAlign: item.tunes.option.alignment}}
                            dangerouslySetInnerHTML={{__html: text}}
                />
            }
            case 'header':
                return <div className={`brand-archive-${item.type}`}
                            style={{textAlign: item.tunes.option.alignment}}
                            dangerouslySetInnerHTML={{__html: item.data.text}}
                />
            case 'image':
                return <div className={`brand-archive-${item.type}`}>
                    <img style={{
                        width: item.data.stretched ? "100%" : "auto",
                        margin: item.data.withBackground ? "auto" : "0"
                    }} src={item.data.file.url}/>
                    <div className={'text-caption'}>{item.data.caption}</div>
                </div>
            case 'embed':
                switch (item.data.service) {
                    case 'youtube':
                        return <div className={`brand-archive-${item.type}`}>
                            <iframe
                                width="100%" height="auto"
                                src={item.data.embed}
                                title="YouTube video player" frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen>
                            </iframe>

                        </div>
                }
                break;
            case 'Images':
                switch (item.data.config) {
                    case 'carousel':
                        return <div className={`brand-archive-${item.type}`}>
                            <TextAndCarousel
                                imageObjArr={item.data.items.map((item: any) => {
                                    return {img: item.url, text: item.caption}
                                })}
                                isBullet={true}
                                paginationId="brandArchiveCarouselPagination"
                            />
                        </div>
                    case 'standard':
                        return <div className={`brand-archive-${item.type}`}>
                            <div className={'brand-archive-gallery'}
                                 style={{gridTemplateColumns: `repeat(${item.data.countItemEachRow}, 1fr)`}}>
                                {item.data.items.map((target: any, key: number) => {
                                    return <div key={key} onClick={() => {
                                        setIsImageModalVisible(true)
                                        setTargetIndex(key)
                                        setTargetImages([...item.data.items])
                                    }}>
                                        <img className={'brand-archive-gallery-item'} src={target.url}/>
                                        <div className={'text-caption'}>{target.caption}</div>
                                    </div>
                                })}
                            </div>
                        </div>
                }
                break;
        }
    }
    if (!data) {
        return (<div style={{minHeight: "100vh"}}></div>)
    }

    return (
        <div className={"brand-archive-wrapper"}>
            <div className={"brand-archive-background-wrapper"}>
                <div className="brand-archive-background-dim"></div>
                <img src={data?.background_url ? data?.background_url : data?.thumbnail_url}/>
            </div>
            <div className={"brand-archive-thumbnail-wrapper"}>
                <img src={data?.thumbnail_url}/>
            </div>
            {isImageModalVisible && (
                <BrandArchiveGalleryImageModalComponent
                    images={targetImages}
                    targetIndex={targetIndex}
                    close={() => {
                        setIsImageModalVisible(false);
                    }}/>
            )}
            <div className="brand-archive-content-wrapper">
                <div className={"brand-archive-description-wrapper"}>
                    <div className="brand-archive-title-wrapper">
                        <div className={"brand-archive-title"}>{data?.title}</div>
                        <div className="brand-archive-list-item-sub-info-wrapper">
                            <div className="brand-archive-list-item-sub-info">
                                {data?.writer}
                                <div className="blank">|</div>
                                {convertMonthV2(new Date(data?.register_date).getMonth())} {new Date(data?.register_date).getDate()}, {new Date(data?.register_date).getFullYear()}
                            </div>
                        </div>
                    </div>
                    {data && data.content && data.content.length > 0 && (
                        data.content.map((item, index) => {
                            return <div key={index}>{convertDataByType(item)}</div>
                        })
                    )}
                </div>
                <div className="brand-archive-navigator">
                    <div className="brand-archive-navigator-item">
                        {prevContent && <>
                            <div className="text-icon-wrapper"
                                 onClick={() => navigate(`/makersnote/${prevContent?.slug}`)}>
                                <div className="img-wrapper">
                                    <SmallArrow/>
                                </div>
                                <div className="text-wrapper">
                                    이전 글
                                </div>
                            </div>
                            <div className="contents-navigator-item-wrapper"
                                 onClick={() => navigate(`/makersnote/${prevContent?.slug}`)}>
                                <div className="contents-img-wrapper">
                                    <img src={prevContent.thumbnail_url}/>
                                </div>
                                <div className="contents-img-description" style={{textAlign: 'left'}}>
                                    {prevContent.title}
                                </div>
                            </div>
                        </>
                        }
                    </div>
                    <div className="brand-archive-navigator-item"
                         style={{
                             alignItems: "baseline",
                             justifyContent: "center",
                             display: "flex"
                         }}>
                        <div className="text-icon-wrapper" onClick={() => {
                            reset()
                            navigate('/makersnote')
                        }}>
                            <div className="img-wrapper">
                                <ListIcon/>
                            </div>
                            <div className="text-wrapper">
                                목록으로
                            </div>
                        </div>
                    </div>
                    <div className="brand-archive-navigator-item" style={{justifyContent: "end"}}>
                        {nextContent &&
                            <>
                                <div className="text-icon-wrapper"
                                     style={{justifyContent: "end"}}
                                     onClick={() => {
                                         reset()
                                         navigate(`/makersnote/${nextContent?.slug}`)
                                     }}>
                                    <div className="text-wrapper">
                                        다음 글
                                    </div>
                                    <div className="img-wrapper" style={{transform: "rotate(180deg)"}}>
                                        <SmallArrow/>
                                    </div>
                                </div>
                                <div className="contents-navigator-item-wrapper"
                                     onClick={() => {
                                         reset()
                                         navigate(`/makersnote/${nextContent?.slug}`)
                                     }}
                                     style={{justifyContent: "end"}}>
                                    <div className="contents-img-description" style={{textAlign: 'right'}}>
                                        {nextContent.title}
                                    </div>
                                    <div className="contents-img-wrapper">
                                        <img src={nextContent.thumbnail_url}/>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BrandArchiveComponent
